module.exports = __webpack_public_path__ + "static/cloud1-29475da184333b0270db4acd6a090b85.png";